import { useState, useEffect, useRef } from 'react'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

// ** Custom Components Import
import MessagesLog from './whatapp-log'
import Image from 'next/image'
import { ClosedCaptionDisabledOutlined } from '@mui/icons-material'

// ** Styled Components
const ChatWrapperStartChat = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  height: '100%',
  display: 'flex',
  borderRadius: 1,
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: theme.palette.action.hover
}))

const TextMessagesContent = props => {
  // ** Props
  const { store, hidden, mdAbove, handleLeftSidebarToggle, handleUserProfileRightSidebarToggle, headImg, advanced } = props

  const [canLoad, setCanLoad] = useState(false)

  useEffect(() => {
    if (!canLoad) {
      if (store && store.list.length > 0) {
        setCanLoad(true)
      }
    }
  }, [store, canLoad])

  const handleStartConversation = () => {
    if (!mdAbove) {
      handleLeftSidebarToggle()
    }
  }

  const renderContent = () => {
    if (!store) {
      return null // 如果 store 不存在，返回 null
    }

    const selectedMessage = store.selectedMessage

    if (!canLoad) {
      return (
        <ChatWrapperStartChat
          sx={{
            ...(mdAbove ? { borderTopLeftRadius: 0, borderBottomLeftRadius: 0 } : {})
          }}
        >
          {advanced && <Box
            onClick={handleStartConversation}
            sx={{
              px: 6,
              py: 2.25,
              boxShadow: 3,
              borderRadius: 5,
              backgroundColor: 'background.paper',
              cursor: mdAbove ? 'default' : 'pointer'
            }}
          >
            <Typography sx={{ fontWeight: 600 }}>Start Conversation</Typography>
          </Box>}
        </ChatWrapperStartChat>
      )
    }

    return (
      <Box
        sx={{
          flexGrow: 1,
          borderTopLeftRadius: { xs: '8px', md: null },
          borderTopRightRadius: { xs: '8px', md: '8px' },
          borderBottomLeftRadius: { xs: '8px', md: null },
          borderBottomRightRadius: { xs: '8px', md: '8px' }
        }}
        className={`bg-[#FFFFFF] w-full flex-1 flex flex-col ${!advanced ? 'blur-[16px] select-none' : ''}`}
      >
        <Box
          sx={{
            py: 3,
            px: 5,
            display: 'flex',
            alignItems: 'center',
            borderBottom: theme => `1px solid ${theme.palette.divider}`,
            height: '68px'
          }}
          className='border-b-[1px] border-black border-opacity-10 justify-between'
        >
          <div className='md:invisible flex-shrink-0'>
            <Image
              src='/images/text-messages/return.svg'
              width={20}
              height={20}
              alt='return'
              onClick={handleLeftSidebarToggle}
            ></Image>
          </div>
          <div className='flex items-center flex-shrink-0'>
            <Image src={'/images/avatars/10.png'} width={40} height={40} alt='avatar' />
            <span className='ml-[10px] text-[#000000] text-[14px] font-[600]'>{selectedMessage.contact.chatid}</span>
          </div>
          <div className='invisible w-[20px] h-[20px]'></div>
        </Box>
        {selectedMessage ? <MessagesLog hidden={hidden} advanced={advanced} data={{ ...selectedMessage }} /> : null}
      </Box>
    )
  }

  return renderContent()
}

export default TextMessagesContent
